// extracted by mini-css-extract-plugin
export default {"coloredBox":"ColoredBox_coloredBox__ozUtp"};